import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from "styled-components";

import GridLayout from "./GridLayout";
import { getFromLS, saveToLS } from "../../utils/localStore/localStore";

const WidgetWrapper = styled.div`
    margin: 0px 0px 0px -${({ offset }) => offset}px;
`

const WidgetGrid = forwardRef(({ draggable, resizable, initialData }, ref) => {
  const id = initialData.name

  // Calculates the OffSet for the Grid to align it to the Title based on the Margin used
  const margins = initialData.setup.margin
  const keys = Object.keys(margins)
  const offset = `${margins[keys[0]][0]}`

  //Loads the Saved Data from Local Store
  let savedData = getFromLS(id, 'data');
  if (!savedData) {
    savedData = initialData;
  }
  const [layouts, setLayouts] = useState(JSON.parse(JSON.stringify(savedData.layouts)));
  const [widgetArray, setWidgetArray] = useState(JSON.parse(JSON.stringify(savedData.widgets)));
  const [isDraggable, setIsDraggable] = useState(draggable);
  const [isResizable, setIsResizable] = useState(resizable);
  const [forceUpdate, setForceUpdate] = useState(false);
  const layoutsSnapshot = useRef(JSON.stringify(savedData.layouts));

  useImperativeHandle(ref, () => ({
    resetLayout() {
      layoutsSnapshot.current = JSON.stringify(initialData.layouts);
      setLayouts(initialData.layouts);
      setWidgetArray(initialData.widgets);
      let data = { layouts: initialData.layouts, widgets: initialData.widgets };
      saveToLS(id, 'data', data);
    },
    setEdit(on) {
      setIsDraggable(on ? true : draggable);
      setIsResizable(on ? true : resizable);
    }
  }));

  const onLayoutChange = (layout, layouts) => {
    const snapshot = JSON.stringify(layouts);
    if (snapshot === layoutsSnapshot.current) return;
    layoutsSnapshot.current = snapshot;
    let data = { layouts: layouts, widgets: widgetArray };
    saveToLS(id, 'data', data);
    setLayouts(layouts);
  };

  const handleDelete = (key) => {
    const tempArray = widgetArray.slice();
    const index = tempArray.indexOf(tempArray.find((data) => data.i === key));
    tempArray.splice(index, 1);
    const newLayouts = updateLayouts(key);
    setLayouts(newLayouts);
    setWidgetArray(tempArray);
    setForceUpdate(!forceUpdate);
  };

  const updateLayouts = (key) => {
    const updatedLayouts = {};
    for (const breakpoint in layouts) {
      updatedLayouts[breakpoint] = layouts[breakpoint].filter((item) => item.i !== key);
    }
    return updatedLayouts;
  };

  return (
    <WidgetWrapper offset={offset}>
      <GridLayout
        layouts={layouts}
        onLayoutChange={onLayoutChange}
        widgetArray={widgetArray}
        isResizable={isResizable}
        isDraggable={isDraggable}
        handleDelete={handleDelete}
        setup={initialData.setup}
        key={forceUpdate}
      />
    </WidgetWrapper>
  );
});

export default WidgetGrid
